import * as RSep from '@radix-ui/react-separator'
import * as RVH from '@radix-ui/react-visually-hidden'
import type { ComponentProps, HTMLAttributes } from 'react'
import { cn } from './cn'

/** Keyboard key hint (11/600, surface-2, 1px line, radius 6). */
export function Kbd({ className, ...rest }: HTMLAttributes<HTMLElement>) {
  return (
    <kbd
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-sm border border-line bg-surface-2 px-1.5',
        'font-sans text-micro text-muted select-none',
        className,
      )}
      {...rest}
    />
  )
}

/** 1px divider (horizontal by default). */
export function Separator({ className, orientation = 'horizontal', decorative = true, ...rest }: ComponentProps<typeof RSep.Root>) {
  return (
    <RSep.Root
      orientation={orientation}
      decorative={decorative}
      className={cn('shrink-0 bg-line', orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px', className)}
      {...rest}
    />
  )
}

/** Content for screen readers only. */
export function VisuallyHidden(props: ComponentProps<typeof RVH.Root>) {
  return <RVH.Root {...props} />
}
